import { render, staticRenderFns } from "./RateFeedback.vue?vue&type=template&id=6308bdf1&scoped=true"
import script from "./RateFeedback.vue?vue&type=script&lang=js"
export * from "./RateFeedback.vue?vue&type=script&lang=js"
import style0 from "./RateFeedback.vue?vue&type=style&index=0&id=6308bdf1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308bdf1",
  null
  
)

export default component.exports